import { render, staticRenderFns } from "./CompanyUsersList.vue?vue&type=template&id=60a70131"
import script from "./CompanyUsersList.vue?vue&type=script&lang=js"
export * from "./CompanyUsersList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports